module.exports = __webpack_public_path__ + "static/media/fingerprint.f8d156e6.svg";